import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from "../assets/logo-branca@2x.png";
import Usuario from "../assets/usuario.svg";
import Exit from "../container/Exit";
import ModalForm from '../pages/User/ModalDados';
import api from "../services/api";
import { ID_CLIENT, NAME_CLIENT, getClientName, getUserName, getToken } from "../services/auth";

import "../styles/modulos.css";

const NavBar = (props) => {

    const [show, setShow] = useState(false)
    const userWrapperShow = () => {
        if (show === false) {
            setShow(true)
        } else {
            setShow(false)
        }
    }
    const [showClient, setShowClient] = useState(false)
    const clientWrapperShow = () => {
        if (showClient === false) {
            fetchClient();
            setShowClient(true)
        } else {
            setShowClient(false)
        }
    }

    let [clientData, setClientData] = useState('');
    const fetchClient = () => {
        api.get('/clientes', { headers: { token: getToken() } })
            .then((response) => {
                setClientData(response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleClick = (id_client, name) => {
        localStorage.setItem(ID_CLIENT, id_client);
        localStorage.setItem(NAME_CLIENT, name);
        window.location.reload();
    }

    return (
        <nav className="dommus-navigation">
            <div className="logo">
                <Link to="/menu">
                    <picture>
                        <img src={Logo} alt="Dommus logo" />
                    </picture>
                </Link>
            </div>
            <div className="right-nav">
                <div className="info-nav">
                {props.client === true ?
                        <div className="modulo-name">
                        <div className="user-acess" onClick={clientWrapperShow}>
                            <picture>
                                <i className="fas fa-users" style={{ fontSize: '40px', marginRight: '15px' }}></i>
                            </picture>
                            <span>{getClientName()}</span>
                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                            <div className={`user-wrapper ${showClient ? 'userWrapperShow' : ''}`}>
                                <ul>
                                    {clientData && clientData.map(client => {
                                        return <li key={client.id}>
                                            <Link to={'#'} onClick={handleClick.bind(this, client.id, client.nome)}><img src={client.logo} style={{borderRadius: '0px', height: '10px'}} alt="Dommus logo" />{client.nome}</Link>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    : ''}
                    
                    <div className="user-acess" onClick={userWrapperShow}>
                        <picture>
                            <img src={Usuario} alt="USUARIO" />
                        </picture>
                        <span>Olá {getUserName()}</span>
                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                        <div className={`user-wrapper ${show ? 'userWrapperShow' : ''}`}>
                            <ul>
                                <li><ModalForm buttonLabel="Meus dados" buttonId="dados" className="modal-lg" /></li>
                                <li><Exit menu={false} /></li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="toggle-menu">
                    <Link className="header__hamburger" to="#" id="toggle">
                        <span className="hamburger__bar"></span>
                        <span className="hamburger__bar"></span>
                        <span className="hamburger__bar"></span>
                    </Link>
                </div>
            </div>
        </nav>
    )
};

export default NavBar;